<template>
  <div class="content">
    <span id="result"></span>
    <template v-if="Array.isArray(albums_list) && albums_list.length">
      <keep-alive>
        <router-view />
      </keep-alive>
      <router-view name="album_item" />
    </template>
    <template else>
      <div
        class="spinner"
        v-if="Array.isArray(albums_list) && !albums_list.length"
      >
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
      <p class="response-error" v-if="albums_list == undefined">
        <span>{{ lng == "tr" ? "Kayıt bulunamadı" : "No Records Found" }}</span>
      </p>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["albums_list", "lng"]),
  },
  watch: {
    async "$route.params.type"(newValue, oldValue) {
      await this.$store.dispatch("albums_list", this.$route.params);
    },
  },
  async created() {
    await this.$store.dispatch("albums_list", this.$route.params);
  },
};
</script>

<style scoped>
</style>